import { render } from "./CallbackPage.vue?vue&type=template&id=44d3aba7&ts=true"
import script from "./CallbackPage.vue?vue&type=script&lang=ts"
export * from "./CallbackPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__